<template>
    <div id="goTop" v-show="toTopDiv" @click="toTop">
        <div class="kidClub_go_top"><img src="../assets/images/go_top_03.png"></div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                toTopDiv:false
            }
        },
        mounted(){
            this.toTopShow()
        },
        methods:{
            toTop(){
                document.body.scrollTop = 0
                this.toTopDiv = false
            },
            toTopShow(){
                document.addEventListener('scroll',()=>{
                    if(document.body.scrollTop > 0){
                        this.toTopDiv = true
                    }else{
                        this.toTopDiv = false
                    }
                })
            }
        }
    }
</script>
<style>
    #goTop {
        width: 100%;
    }
    
    .kidClub_go_top {
        width: 48px;
        height: 48px;
        right: 10px;
        bottom: 17px;
        cursor: pointer;
        z-index: 10;
        border-radius: 50%;
        animation: translateY .2s linear forwards;
        -moz-animation: translateY .2s linear forwards;
        -ms-animation: translateY .2s linear forwards;
        -o-animation: translateY .2s linear forwards;
        position: fixed;
        background-color: rgba(0, 0, 0, .5);
    }
    
    .kidClub_go_top img {
        width: 27px;
        height: 15px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
</style>


// WEBPACK FOOTER //
// ToTop.vue?8e95c90a